<!--表单分页组件组件 -->
<template>
    <div :paginations="undefined" style="overflow:hidden;">
            <!-- element-loading-background="rgba(0, 0, 0, 0.25)"
            element-loading-text="拼命加载中" -->
        <el-table ref="tablePagination" v-loading="$attrs.loading" :data="data" v-bind="$attrs" v-on="$listeners" :tableColumns="undefined" :paginations="undefined">
            <template v-for="column in tableColumns">
                <el-table-column v-bind="column" v-if="column.slot" slot="" :key="column.key" >
                    <template slot-scope="scope">
                        <slot :name="column.prop" :row="scope.row" :$index="scope.$index" />
                    </template>
                </el-table-column>
                <el-table-column v-else v-bind="column" :key="column.key" show-overflow-tooltip >
                    <!-- <el-tooltip v-if="column.tips" :content="column.tips" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip> -->
                    <template v-if="column.child">
                        <el-table-column  v-for="item in column.child" :key="item.key" v-bind="item" />
                    </template>
                    <template slot="header" >
                        <span>{{column.label}}</span>
                        <el-tooltip v-if="column.tips"  :content="column.tips" placement="top">
                        <i class="el-icon-question" style="color:#5cb6ff;"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <el-col :span="24" class="btm-action">
            <el-pagination v-if="$attrs.paginations&&$attrs.paginations.total>0" class="pagination" :page-sizes="$attrs.paginations.pageSizes" :page-size="$attrs.paginations.pageSize" :layout="$attrs.paginations.layout" :total="$attrs.paginations.total" :pageNum="$attrs.paginations.pageNum" @current-change="onChangeCurrentPage"></el-pagination>
        </el-col>
    </div>
</template>

<script>
export default {
  props: {
    data: {// 表单数据
      type: Array,
      default: () => ([]),
    },
    tableColumns: {// 配置表头数据
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {};
  },
  methods: {
    onChangeCurrentPage(obj) { // 分页方法
      this.$emit('onChangeCurrentPage', obj);
    },
  },
};
</script>

<style>
.btm-action {
  margin-top: 20px;
  text-align: center;
}
.pagination {
  display: inline-block;
}
</style>
